import { useAuth0 } from '@auth0/auth0-react';
import { useUserStatus } from '../../context/UserStatusContext';
import { linkAccount } from '../../services/apiService';
import styles from './ConnectedAccounts.module.css';

const PROVIDER_INFO = {
  'google-oauth2': { name: 'Google', icon: 'fab fa-google' },
  linkedin: { name: 'LinkedIn', icon: 'fab fa-linkedin' },
};

const ConnectedAccounts = () => {
  const { getAccessTokenWithPopup, getAccessTokenSilently } = useAuth0();
  const { userStatus, refreshUserStatus } = useUserStatus();

  // Get a simple list of provider names, e.g., ['google-oauth2', 'linkedin']
  const connectedProviders =
    userStatus?.connectedAccounts?.map((acc) => acc.provider) || [];

  const handleConnect = async (connectionName) => {
    try {
      const secondaryToken = await getAccessTokenWithPopup({
        authorizationParams: { connection: connectionName },
      });
      const primaryToken = await getAccessTokenSilently();
      await linkAccount({ secondary_token: secondaryToken }, primaryToken);

      await refreshUserStatus();
    } catch (error) {
      console.error('Failed to link account:', error);
      if (error.message.includes('already linked to a different')) {
        alert(
          'This social account is already linked to a different Ego Protocol user.'
        );
      } else {
        alert('Could not link account. The user may have closed the popup.');
      }
    }
  };

  const isConnected = (connectionName) =>
    connectedProviders.includes(connectionName);

  return (
    <div className={styles.settingsCard}>
      <h3>Connected Accounts</h3>
      <p className={styles.cardDescription}>
        Manage the social accounts you use to sign in to Ego Protocol.
      </p>
      <div className={styles.accountList}>
        {Object.entries(PROVIDER_INFO).map(([connection, info]) => (
          <div key={connection} className={styles.accountItem}>
            <div className={styles.accountInfo}>
              <i className={info.icon}></i>
              <span>{info.name}</span>
            </div>
            {isConnected(connection) ? (
              <span className={styles.connectedBadge}>Connected</span>
            ) : (
              <button
                onClick={() => handleConnect(connection)}
                className="action-button secondary"
              >
                Connect
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ConnectedAccounts;
